import { round } from "lodash/lodash";
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string')) {
            if ((/^[0-9]+$/.test(time))) {
                // support "1548221490638"
                time = parseInt(time)
            } else {
                // support safari
                // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
                time = time.replace(new RegExp(/-/gm), '/')
            }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
 * @param {number} time
 * @returns {string}
 */
export function formatDuration(time) {
    let second = Math.floor(time / 1000);
    let miao = Math.floor(second % 60);
    let mintes = Math.floor((second / 60) % 60);
    let hours = Math.floor(second / 3600);
    miao = miao > 9 ? miao : `0${miao}`
    mintes = mintes > 9 ? mintes : `0${mintes}`
    hours = hours > 9 ? hours : `0${hours}`
    return hours + ":" + mintes + ":" + miao;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) s++
        else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xDC00 && code <= 0xDFFF) i--
    }
    return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
    if (!json) return ''
    return cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ''
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
    ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
    if (!search) {
        return {}
    }
    const obj = {}
    const searchArr = search.split('&')
    searchArr.forEach(v => {
        const index = v.indexOf('=')
        if (index !== -1) {
            const name = v.substring(0, index)
            const val = v.substring(index + 1, v.length)
            obj[name] = val
        }
    })
    return obj
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
    if (typeof target !== 'object') {
        target = {}
    }
    if (Array.isArray(source)) {
        return source.slice()
    }
    Object.keys(source).forEach(property => {
        const sourceProperty = source[property]
        if (typeof sourceProperty === 'object') {
            target[property] = objectMerge(target[property], sourceProperty)
        } else {
            target[property] = sourceProperty
        }
    })
    return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
    if (!element || !className) {
        return
    }
    let classString = element.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString =
            classString.substr(0, nameIndex) +
            classString.substr(nameIndex + className.length)
    }
    element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
    if (type === 'start') {
        return new Date().getTime() - 3600 * 1000 * 24 * 90
    } else {
        return new Date(new Date().toDateString())
    }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function (...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
    return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}


/**
 * 判断经度是否正确
 * @param {any} lng
 * @returns {Boolean} 返回经度是否正确
 */
export function isLng(lng) {
    const regex = /^(-?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?))$/;
    return regex.test(lng) && lng >= -180 && lng <= 180;
}


/**
 * 判断纬度是否正确
 * @param {any} lat 纬度
 * @returns {Boolean} 返回纬度是否正确
 */
export function isLat(lat) {
    const regex = /^(?:-?(?:[1-8]?\d(\.\d+)?|90(\.0+)?))$/;
    return regex.test(lat) && lat >= -90 && lat <= 90;
}

/**
 * 公制转英制
 * @param {Number} value
 */
export function metric2imperial(value) {
    return value * 3.2808;
}

/**
 * 英制转公制
 * @param {Number} value
 */
export function imperial2metric(value) {
    return (value * 1) / 3.2808;
}

/**
 * 公制转英制速度（m/s => mph）
 * @param {Number} value
 */
export function speed_metric2imperial(value) {
    const kph = (value * 3600) / 1000; // km/h或者kph
    const mph = kph * 0.6213712;
    return mph; // mi/h或者mph
}

/**
 * 英制转公制速度（mph => m/s）
 * @param {Number} value
 */
export function speed_imperial2metric(value) {
    const kph = ((value * 1 / 0.6213712) * 1000) / 3600; // km/h或者kph
    return kph;
}

/**
 * 字节单位转换
 * @param {Number} bytes
 * @returns {string}
 */
export function convertBytes(bytes) {
    // const sizes = ["B", "KB", "MB", "GB", "TB"];
    const sizes = ["B", "K", "M", "G", "T"];
    if (bytes == 0) return "0B";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return round(bytes / Math.pow(1024, i), 3) + sizes[i];
}

/**
 * 判断是否是数字（包括正数、负数和小数）
 * @param {string} str
 * @returns {boolean}
 */
export function isNumber(str) {
    const regex = /^[+-]?\d+(\.\d+)?$/;
    return regex.test(str);
}

/**
 * 判断是否为正整数
 * @param {string} str
 * @returns {boolean}
 */
export function isPositiveInteger(str) {
    const regex = /^(?!0)\d+$/;
    return regex.test(str);
}

/**
 * 检查值是否为大于0的数字
 * @param {string|number} val - 要检查的值
 * @returns {boolean} 是否为大于0的数字
 */
export function isPositiveNumber(val) {
    // 如果是数字类型，直接判断
    if (typeof val === 'number') {
        return val > 0 && Number.isFinite(val);
    }

    // 如果是字符串，去掉前后空格再判断
    if (typeof val === 'string') {
        val = val.trim();
        // 正则：匹配大于0的数字（整数或小数）
        return /^(?:0*[1-9]\d*(?:\.\d+)?|0*\.\d*[1-9]\d*)$/.test(val);
    }

    // 其他类型（null、undefined、对象等）直接返回 false
    return false;
}

/**
 * 判断一个值是否为合法数字（整数或小数，最多一个小数点）
 * @param {*} val - 要检测的值
 * @param {Object} [options] - 可选配置
 * @param {boolean} [options.allowSign=false] - 是否允许正负号
 * @param {number} [options.maxDecimals=null] - 限制小数位数（null 表示不限制）
 * @returns {boolean} 是否为合法数字
 */
export function isValidNumericValue(val, options = {}) {
    const { allowSign = false, maxDecimals = null } = options;

    // 如果是数字类型，直接判断
    if (typeof val === 'number') {
        if (!Number.isFinite(val)) return false;
        if (maxDecimals !== null) {
            const decimals = (val.toString().split('.')[1] || '').length;
            return decimals <= maxDecimals;
        }
        return true;
    }

    // 如果是字符串类型
    if (typeof val === 'string') {
        val = val.trim();
        if (val === '') return false;

        // 构建正则
        const signPart = allowSign ? '[+-]?' : '';
        const decimalPart =
            maxDecimals === 0
                ? '' // 不允许小数
                : maxDecimals === null
                    ? '(\\.\\d+)?' // 不限制小数位数
                    : `(\\.\\d{1,${maxDecimals}})?`; // 限制小数位数

        const re = new RegExp(`^${signPart}\\d+${decimalPart}$`);

        return re.test(val);
    }

    // 其他类型（对象、null、undefined）都不是数字
    return false;
}

/**
 * 判断值是否符合数字规则
 * @param {string|number} val - 待验证的值
 * @param {Object} options - 配置项
 * @param {number|null} [options.maxDecimals=1] - 小数位数最大值，null表示不限制
 * @param {boolean} [options.allowSign=false] - 是否允许正负号（默认不允许负数）
 * @param {number|null} [options.min=null] - 最小值（默认不限制）
 * @param {number|null} [options.max=null] - 最大值（默认不限制）
 * @param {boolean} [options.allowDotStart=false] - 是否允许以 . 开头（如 .5）
 * @returns {boolean} 是否符合要求
 */
export function isValidNumber(val, options = {}) {
    const { maxDecimals = 1, allowSign = false, min = null, max = null, allowDotStart = false } = options;

    // 处理数字类型
    if (typeof val === 'number') {
        if (!Number.isFinite(val)) return false;
        if (!allowSign && val <= 0) return false;
        if (allowSign && val === 0) return false;
        if (maxDecimals !== null) {
            const decimals = (val.toString().split('.')[1] || '').length;
            if (decimals > maxDecimals) return false;
        }
        if (min !== null && val < min) return false;
        if (max !== null && val > max) return false;
        return true;
    }

    // 处理字符串类型
    if (typeof val === 'string') {
        let str = val.trim();
        if (!str) return false;

        // 构建正则
        const signPart = allowSign ? '[+-]?' : '';
        const integerPart = allowDotStart ? '\\d*' : '\\d+'; // 是否允许 .5 这种形式
        const decimalPart =
            maxDecimals === 0
                ? '' // 不允许小数
                : maxDecimals === null
                    ? '(\\.\\d+)?' // 不限制小数位
                    : `(\\.\\d{1,${maxDecimals}})?`;

        const re = new RegExp(`^${signPart}${integerPart}${decimalPart}$`);

        if (!re.test(str)) return false;

        const num = parseFloat(str);
        if (!allowSign && num <= 0) return false;
        if (allowSign && num === 0) return false;
        if (min !== null && num < min) return false;
        if (max !== null && num > max) return false;

        return true;
    }

    return false; // 其他类型
}
